import { SHOW_TOAST, HIDE_TOAST } from '../actions/toast-actions';

const initialState = {
    items: []
};

export default function toastReducer(state = initialState, action) {
    switch (action.type) {
        case SHOW_TOAST:
            return {
                ...state,
                items: [...state.items, action.payload]
            };

        case HIDE_TOAST:
            return {
                ...state,
                items: state.items.filter(t => t.id !== action.payload.id)
            };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./containers/console/reducers/toast-reducer.js